<script>
export default {
  functional: true,
  props: {
    percentage: {
      type: [String,Number],
      default: "50%"
    },
    visible: {
      type: Boolean,
      default: false
    }
  },

  render(h, { props }) {
    // let _self = this;
    const { percentage, visible } = props;
    if (visible) {
      return (
        <div class="Battery">
          <img
            class="Battery__img"
            src={require("@/assets/img/home/battery_1.png")}
            draggable="false"
          />
          <div class="Battery__content">
            <div
              class="Battery__range"
              style={{ top: 100 - (percentage ) + "%" }}
            ></div>
          </div>
        </div>
      );
      // return h(
      //   "div",
      //   {
      //     class: {
      //       Battery: true
      //     },
      //     on: {
      //       // click: this.clickHandler  一般点击事件
      //       click: function() {
      //         _self.$emit("myClick");
      //       }
      //     }
      //   },
      //   [
      //     h("img", {
      //       attrs: {
      //         src: require("@/assets/img/home/battery_1.png"),
      //         alt: "",
      //         draggable: false
      //       },
      //       class: {
      //         Battery__img: true
      //       }
      //     }),
      //     h("i", {
      //       class: {
      //         "iconfont icon-setting": true,
      //         detail: true
      //       }
      //     }),
      //     h(
      //       "span",
      //       {
      //         class: {
      //           detailtxt: true
      //         }
      //       },
      //       "详情"
      //     ),
      //     h(
      //       "div",
      //       {
      //         class: {
      //           Battery__content: true
      //         }
      //       },
      //       [
      //         h("div", {
      //           class: {
      //             Battery__range: true
      //           },
      //           style: {
      //             top: 100 - percentage + "%"
      //           }
      //         })
      //       ]
      //     )
      //   ]
      // );
    }
    return (
      <div class="Tip">
        <img
          class="Tip__img"
          src={require("@/assets/img/home/Tip.gif")}
          draggable="false"
        />
      </div>
    );
  }
};
</script>

<style lang="scss" scoped>
.test {
  width: 100px;
  height: 100px;
  background-color: red;
  overflow: hidden;
}
.Battery {
  width: 50px;
  position: relative;
  user-select: none;
  // cursor: pointer;
  .detail {
    z-index: 999;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -7px;
    margin-top: -5px;
    color: rgb(0, 0, 0);
  }
  .detailtxt {
    z-index: 999;
    position: absolute;
    top: 70%;
    left: 50%;
    margin-left: -13px;
    margin-top: -5px;
    color: rgb(0, 0, 0);
  }
  &__img {
    width: 100%;
  }

  &__content {
    position: absolute;
    bottom: 3.5%;
    top: 7.5%;
    left: 1%;
    right: 1.2%;
  }

  &__range {
    position: absolute;
    top: 90%;
    bottom: 0;
    left: 0;
    right: 1px;
    border-radius: 1px;
    background: linear-gradient(
      90deg,
      rgba(0, 183, 57, 1),
      rgba(3, 255, 64, 1),
      rgba(1, 235, 80, 1),
      rgba(0, 208, 106, 1),
      rgba(28, 251, 125, 1),
      rgba(63, 255, 120, 1),
      rgba(109, 255, 140, 1),
      rgba(12, 253, 52, 1)
    );
  }
}
.Tip {
  margin-top: 10%;
  position: relative;
  user-select: none;
  &__img {
    width: 100%;
  }
}
</style>
